// Eigenbau: Das Maskottchen als Bild. Tremor hat keinen Avatar-Baustein, und
// die Bausteine mit Bildbezug im Bestand tragen alle ein Diagramm, kein Motiv.

import rabe from "@/bilder/rabe-128.png";
import { cx } from "@/lib/utils";

/**
 * Der Rabe als Avatar.
 *
 * Zuständig überall dort, wo der Rabe als Gesicht auftritt: Metarr in der
 * Leiste, der Gruß auf dem Dashboard, die Leerzustände. Für das Zeichen der
 * Firma ist [`Wortmarke`](./Wortmarke.tsx) zuständig — dort steht der Rabe im
 * Würfel, hier steht er allein im Kreis.
 *
 * Unter etwa 24px lohnt das Foto nicht mehr: Es bleibt ein dunkler Fleck mit
 * türkisem Rand. Das ist als Erkennungszeichen noch brauchbar, als Porträt
 * nicht — wer kleiner braucht, sollte stattdessen Initialen setzen, so wie es
 * `UserProfile` für Personen tut.
 *
 * Das Bild ist bereits rund freigestellt (siehe `bilder/HERKUNFT.md`). Der
 * `rounded-full`-Zuschnitt hier ist trotzdem gesetzt — er kostet nichts und
 * hält die Form, falls die Datei einmal quadratisch ersetzt wird.
 */
export function RabeAvatar({
  groesse = 40,
  className,
  titel = "",
}: {
  /** Kantenlänge in Pixeln. Die Datei liegt in 128px vor und trägt bis dahin. */
  groesse?: number;
  className?: string;
  /**
   * Leer heißt schmückend — dann wird das Bild für Vorlesesoftware
   * ausgeblendet. Das ist der richtige Fall überall dort, wo direkt daneben
   * schon steht, um wen es geht („Metarr", eine Überschrift, die Wortmarke).
   */
  titel?: string;
}) {
  return (
    <img
      src={rabe}
      alt={titel}
      {...(titel === "" ? { "aria-hidden": true } : {})}
      width={groesse}
      height={groesse}
      // `flex-none`, damit der Avatar in einer engen Zeile nicht gestaucht
      // wird; Breite und Höhe stehen zusätzlich als Attribute, damit beim
      // Laden nichts springt.
      className={cx("block flex-none rounded-full object-cover", className)}
      style={{ width: groesse, height: groesse }}
      draggable={false}
    />
  );
}
